<template>
  <!-- <div v-if="showForm"> -->
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div v-if="!showForm">
        <spinner />
      </div>
      <div v-else>
        <div class="row details-area">
          <b-form class="col-xs-12">
            <div class="header-form">
              <div v-if="formType == 'edit'">Editar setor {{ oldName }}</div>
              <div v-else>Adicionar setor</div>
            </div>
            <div class="col-xs-12">
              <b-form-text id="sectorNameInputLiveHelp"> Nome * </b-form-text>
              <b-form-input
                v-model.trim="form.NAME"
                placeholder="Nome"
                aria-describedby="sectorNameInputLiveHelp sectorNameInputLiveFeedback"
                :state="nameState && notRepeatedName"
                maxlength="24"
                id="sectorNameInput"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!nameState"
                id="sectorNameInputLiveFeedback"
              >
                Campo inválido
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!notRepeatedName">
                Esse nome já está em uso
              </b-form-invalid-feedback>

              <b-form-text id="sectorAreaInputLiveHelp"> Área * </b-form-text>
              <b-form-input
                v-model="form.AREA"
                placeholder="Área"
                aria-describedby="sectorAreaInputLiveHelp sectorAreaInputLiveFeedback"
                :state="areaState"
                maxlength="24"
                id="sectorAreaInput"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!areaState"
                id="sectorAreaInputLiveFeedback"
              >
                Campo inválido (casas decimais pós ponto)
              </b-form-invalid-feedback>

              <b-form-text id="sectorTypeInputLiveHelp">
                Fruto cultivado
              </b-form-text>

              <!-- É setor de manejo -->
              <b-btn
                v-if="managementForm && managementForm.IS_MANAGEMENT"
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'farm',
                    typeName: 'Cultiavres',
                    selectType: 'selectRadio',
                    items: managementFarms,
                    selected: selected.farm,
                  })
                "
                variant="orange"
                >Fruto cultivado
              </b-btn>
              <div
                class="selected-box"
                v-if="managementForm && managementForm.IS_MANAGEMENT"
              >
                <div class="selected-item">
                  {{ managementForm.FARM_NAME }}
                </div>
              </div>
              <b-form-input
                v-else
                v-model="form.PLANTING_TYPE"
                placeholder="Fruto cultivado"
                aria-describedby="sectorTypeInputLiveHelp sectorTypeInputLiveFeedback"
                :state="true"
                maxlength="24"
                size="sm"
                id="sectorTypeInput"
              />
              <b-form-invalid-feedback
                v-if="!farmState"
                id="sectorFarmInputLiveFeedback"
              >
                É necessário escolher um cultivar
              </b-form-invalid-feedback>

              <b-form-checkbox
                v-if="hasAccess"
                size="sm"
                v-model="managementForm.IS_MANAGEMENT"
                switch
                class="my-3"
              >
                Realizar manejo de irrigação no setor?
              </b-form-checkbox>
              <div v-if="!hasAccess">
                <b-form-text id="sectorDateInputLiveHelp">
                  Data de plantio
                </b-form-text>
                <b-form-input
                  v-model="form.PLANTING_DATE"
                  type="date"
                  :state="true"
                  size="sm"
                  aria-describedby="sectorDateInputLiveHelp"
                  id="sectorDateInput"
                />
              </div>

              <!-- Informações importantes para Manejo-->
              <span v-if="managementForm.IS_MANAGEMENT">
                <b-form-text> Solo *</b-form-text>
                <b-btn
                  v-if="managementForm && managementForm.IS_MANAGEMENT"
                  block
                  size="sm"
                  squared
                  @click="
                    openModal('PickEquipmentsModal', {
                      elementsType: 'soil',
                      typeName: 'Solos',
                      selectType: 'selectRadio',
                      items: managementSoil,
                      selected: selected.soil,
                    })
                  "
                  variant="orange"
                  >Solo
                </b-btn>
                <div
                  class="selected-box"
                  v-if="managementForm && managementForm.IS_MANAGEMENT"
                >
                  <div class="selected-item">
                    {{ this.managementForm.SOIL_NAME }}
                  </div>
                </div>

                <b-form-invalid-feedback
                  v-if="!soilState"
                  id="sectorSoilInputLiveFeedback"
                >
                  É necessário escolher um solo
                </b-form-invalid-feedback>

                <b-form-text id="sectorDateInputLiveHelp">
                  Espaçamento entre Linhas (m)*
                </b-form-text>
                <b-form-input
                  v-model="managementForm.SPACING_BETWEEN_LINES"
                  type="number"
                  :state="spaceBetweensLinesState"
                  size="sm"
                  aria-describedby="sectorDateInputLiveHelp"
                  id="sectorDateInput"
                />

                <b-form-text id="sectorDateInputLiveHelp">
                  Espaçamento entre Plantas (m)*
                </b-form-text>
                <b-form-input
                  v-model="managementForm.SPACING_BETWEEN_PLANTS"
                  type="number"
                  :state="spaceBetweensPlantsState"
                  size="sm"
                  aria-describedby="sectorDateInputLiveHelp"
                  id="sectorDateInput"
                />

                <b-form-text id="sectorDateInputLiveHelp">
                  Taxa de Aplicação (mm/h)*
                </b-form-text>
                <b-form-input
                  v-model="managementForm.APPLICATION_RATE"
                  type="number"
                  :state="applicationRateState"
                  size="sm"
                  aria-describedby="sectorDateInputLiveHelp"
                  id="sectorDateInput"
                />

                <b-form-text id="sectorDateInputLiveHelp">
                  Eficiência do Sistema (%)*
                </b-form-text>
                <b-form-input
                  v-model="managementForm.SYSTEM_EFFICIENCY"
                  type="number"
                  :state="systemEfficiencyState"
                  size="sm"
                  aria-describedby="sectorDateInputLiveHelp"
                  id="sectorDateInput"
                />

                <b-form-invalid-feedback
                  v-if="!systemEfficiencyState"
                  id="sectorDateInputLiveFeedback"
                >
                  Campo obrigatório e permitido apenas número entre 1 e 100.
                </b-form-invalid-feedback>

                <b-form-text id="sectorDateInputLiveHelp" class="mt-4">
                  Data inicial de manejo
                </b-form-text>

                <b-form-input
                  v-model="managementForm.VOLUME_DATE"
                  type="date"
                  size="sm"
                  aria-describedby="sectorVolumeDateInputLiveHelp"
                  id="sectorVolumeDateInput"
                  lazy-formatter
                  :state="validManagementDate"
                />
                <!-- <b-form-invalid-feedback
                v-if="!isValidStationStart && firstEt0Register"
              >
                Só é possível criar manejo a partir do dia:
                {{ moment(firstEt0Register).format("DD/MM/YYYY") }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback
                v-if="!isValidStationStart && !firstEt0Register"
              >
                Não existem dados de ET0 e precipitação registrados ainda,
                cadastre-os antes de registrar o setor.
              </b-form-invalid-feedback> -->

                <b-form-text id="sectorDateInputLiveHelp">
                  Data de plantio
                </b-form-text>
                <b-form-input
                  v-model="form.PLANTING_DATE"
                  type="date"
                  size="sm"
                  :state="plantingDateState"
                  aria-describedby="sectorDateInputLiveHelp"
                  id="sectorDateInput"
                />

                <b-form-text id="sectorDateInputLiveHelp">
                  Data de colheita
                </b-form-text>
                <b-form-input
                  v-model="managementForm.DATE_CROP"
                  type="date"
                  :state="dateCropState"
                  size="sm"
                  debounce="500"
                  aria-describedby="sectorDateInputLiveHelp"
                  id="sectorDateInput"
                />
                <b-form-invalid-feedback
                  v-if="!dateCropState"
                  id="sectorDateCropInputLiveFeedback"
                >
                  É necessário informar a data de colheita, e ela deverá ser
                  superior a data de plantio e data inicial de manejo.
                </b-form-invalid-feedback>

                <b-form-text id="sectorStorageInputLiveHelp">
                  Armazenamento Inicial (mm)</b-form-text
                >
                <b-form-input
                  v-model="managementForm.INITIAL_STORAGE"
                  type="number"
                  placeholder="Armazenamento inicial"
                  aria-describedby="sectorStorageInputLiveHelp sectorStorageInputLiveFeedback"
                  maxlength="24"
                  id="sectorStorageInput"
                  size="sm"
                />
                <div
                  v-if="managementForm.MAX_STORAGE >= 0"
                  class="max-storage-feedback mb-3"
                >
                  Armazenamento máximo: {{ managementForm.MAX_STORAGE }} mm
                </div>
              </span>

              <b-form-text id="sectorNoteInputLiveHelp">
                Observações
              </b-form-text>
              <b-form-textarea
                id="textarea"
                v-model="form.NOTE"
                placeholder="Observações..."
                maxlength="65553"
                rows="5"
                size="sm"
              ></b-form-textarea>
              <p class="count-notes-chars">
                {{ form.NOTE ? form.NOTE.length : 0 }}/65535
              </p>
            </div>

            <div class="col-xs-12">
              <div class="group-inputs-title">Equipamentos:</div>
              <b-btn
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'valves',
                    typeName: 'Válvulas',
                    selectType: 'selectCheckBox',
                    items: valves,
                    selected: selected.valves,
                  })
                "
                variant="orange"
                >Adicionar ou remover Válvulas ({{ selected.valves.length }}/{{
                  valves.length
                }})</b-btn
              >
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selected.valves"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
              <b-alert
                v-for="(item, index) in valveSelectionInputFeedback"
                :key="index"
                variant="warning"
                show
                class="py-2 px-3 mb-2"
              >
                A válvula <strong>{{ item.valve }}</strong> já está associada
                aos seguintes setores: {{ item.sectors }}
              </b-alert>

              <b-btn
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'hydros',
                    typeName: 'Hidrômetros',
                    selectType: 'selectCheckBox',
                    items: hydros,
                    selected: selected.hydros,
                  })
                "
                variant="orange"
                :disabled="managementForm.IS_MANAGEMENT"
                >Adicionar ou remover Hidrômetros ({{
                  selected.hydros.length
                }}/{{ hydros.length }})</b-btn
              >
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selected.hydros"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
              <b-btn
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'sensors',
                    typeName: 'Sensores',
                    selectType: 'selectCheckBox',
                    items: sensors,
                    selected: selected.sensors,
                  })
                "
                variant="orange"
                >Adicionar ou remover Sensores ({{ selected.sensors.length }}/{{
                  sensors.length
                }})</b-btn
              >
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selected.sensors"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
              <b-btn
                block
                size="sm"
                squared
                @click="
                  openModal('PickEquipmentsModal', {
                    elementsType: 'pumps',
                    typeName: 'Bombas',
                    selectType: 'selectCheckBox',
                    items: pumps,
                    selected: selected.pumps,
                  })
                "
                variant="orange"
                :disabled="managementForm.IS_MANAGEMENT"
                >Adicionar ou remover Bombas ({{ selected.pumps.length }}/{{
                  pumps.length
                }})</b-btn
              >
              <div class="selected-box">
                <div
                  class="selected-item"
                  v-for="(sel, index) in selected.pumps"
                  :key="index"
                >
                  {{ sel.NAME }}
                </div>
              </div>
            </div>
          </b-form>
        </div>
        <b-modal
          ref="alertValves"
          no-close-on-backdrop
          centered
          hide-footer
          body-bg-variant="light"
          title="Atenção!"
        >
          <div class="modal-form row pb-3">
            <div class="col-xs-12 center-xs">
              <alert-icon title="" style="font-size: 3em; color: #ffc107" />
            </div>
            <div class="col-xs-12 error-title">
              A válvula escolhida possui registros de volumes divergentes da
              válvula anterior, ao realizar a troca irá apagar os dados antigos
              já salvos atrelados a válvula e com isso novos dados de volumes
              serão calculados.
            </div>
          </div>
          <b-btn
            v-if="$refs.alertValves"
            block
            variant="secondary"
            size="sm"
            @click="ignoreAlertsFromValve"
          >
            Estou ciente
          </b-btn>
        </b-modal>

        <b-modal
          ref="formError"
          no-close-on-backdrop
          centered
          hide-footer
          body-bg-variant="light"
          title="Atenção!"
        >
          <div class="modal-form row pb-3">
            <div class="col-xs-12 center-xs">
              <alert-icon title="" style="font-size: 3em; color: #ffc107" />
            </div>
            <div class="col-xs-12 error-title">
              Não é possível realizar a busca de dados porque:
            </div>

            <div class="col-xs-12 error-description">
              <ul>
                <li v-for="err in errors" :key="err">{{ err }}</li>
              </ul>
            </div>
          </div>
          <b-btn
            v-if="$refs.formError"
            block
            variant="secondary"
            size="sm"
            @click="$refs.formError.hide"
          >
            Irei corrigir
          </b-btn>
        </b-modal>
        <!-- MODAL COM EQUIPAMENTOS -->
        <component
          :is="modalName"
          v-if="showEquipmentsModal"
          v-model="showEquipmentsModal"
          :elementsType="modalElements.elementsType"
          :typeName="modalElements.typeName"
          :equipments="modalElements.items"
          :selectType="modalElements.selectType"
          :selected="modalElements.selected"
          @selected="setSelected"
        />
        <footer id="footer" class="pb-2 d-flex">
          <b-btn
            size="sm"
            @click="
              () => {
                resetForm();
                $emit('close-form');
              }
            "
            variant="outline-secondary"
            class="ml-1 mr-2 w-100"
          >
            Cancelar
          </b-btn>
          <b-btn
            variant="3v3"
            size="sm"
            @click="checkForm"
            class="ml-1 mr-2 w-100"
          >
            Salvar
          </b-btn>
        </footer>
        <b-modal
          centered
          ref="dialogWait"
          no-close-on-backdrop
          no-close-on-esc
          size="sm"
          hide-header
          hide-footer
        >
          <div class="center-xs">
            <spinner />
          </div>
          <div class="center-xs pt-3" v-if="currentLoadingMessage">
            {{ currentLoadingMessage }}
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import {
  hydros,
  management,
  monit,
  pumps,
  sectors,
  sensors,
  valves,
} from "@/api";
import { checkIfFarmDapExists } from "@/api/modules/farms_dap/useCases/checkIfExistsFarmDap";
import { getManagementRainfallInputByIdlUseCase } from "@/api/modules/management/useCase/getRainfallInputsByIdSector";
import { managementSectorUseCases } from "@/api/modules/sector/useCases";
import PickEquipmentsModal from "@/common/components/PickEquipmentsModal.vue";
import managementSectorsActions from "@/mixins/managementSectorActions.js";
import { cookies } from "@/pages/components/cookies";
import { notRepeatedName } from "@/pages/components/regist/form-functions";
import store from "@/store";
import moment from "moment";
import { farmUseCase } from "../../../../api/modules/farm/useCases";
import { getFarmDapByFarmAndDAPUseCase } from "../../../../api/modules/farms_dap/useCases/getByFarmAndDap";
import { getFarmDapByLastRecordUseCase } from "../../../../api/modules/farms_dap/useCases/getLastRecordFromFarmDAP";
import { soilUseCase } from "../../../../api/modules/soil/useCases";
import { showLasRecord } from "../../../../api/modules/valve/useCases/showLastLog";
import { fixFloatValue } from "../../../components/helpers";
export default {
  name: "sector-form",
  components: { PickEquipmentsModal },
  props: {
    // showForm: Boolean,
    formType: String,
    alreadyUsedNames: Array,

    //  hydros: Array,
    //  pumps: Array,
    //  valves: Array,
    //  sensors: Array,
    items: {
      required: false,
      default: () => [],
    },
    itemToEdit: [Number, Object],
  },
  mixins: [managementSectorsActions],
  async created() {
    if (this.hasAccess) {
      await this.loadFarms();
      await this.loadSoils();
    }

    this.hasManagementAcess = JSON.parse(
      localStorage.getItem(`ADD_ONS_ACCESS`)
    ).MANAGEMENT;
    //this.isAdmin = Number(cookies.get("PERMISSION")) == 1
    this.hasAccess = store.getters.isAdmin;
    if (this.formType == "add") {
      this.resetForm();
      this.loadEquipments(this.formType);
    } else {
      this.loadEquipments(this.formType);
      this.form.ID = this.itemToEdit.ID;
      this.form.NAME = this.itemToEdit.NAME;
      this.form.AREA = this.itemToEdit.AREA;
      this.form.PLANTING_TYPE = this.itemToEdit.PLANTING_TYPE;
      this.form.PLANTING_DATE = this.itemToEdit.PLANTING_DATE;
      this.form.NOTE = this.itemToEdit.NOTE;
      this.oldValveItem = [...this.selected.valves];
      if (this.itemToEdit.ID_SOIL) {
        this.managementForm = {
          START_NEW_CYCLE: true,
          OFFSET_DAP: this.itemToEdit.OFFSET_DAP,
          DATE_CROP: this.itemToEdit.DATE_CROP,
          SPACING_BETWEEN_LINES: this.itemToEdit.SPACING_BETWEEN_LINES,
          SPACING_BETWEEN_PLANTS: this.itemToEdit.SPACING_BETWEEN_PLANTS,
          PRESSURIZE_TIME: this.itemToEdit.PRESSURIZE_TIME,
          TIME_ADVANCE: this.itemToEdit.TIME_ADVANCE,
          AVG_TIME_PULSE: this.itemToEdit.AVG_TIME_PULSE,
          APPLICATION_RATE: this.itemToEdit.APPLICATION_RATE,
          SYSTEM_EFFICIENCY: this.itemToEdit.SYSTEM_EFFICIENCY * 100,
          ID_SECTOR: this.itemToEdit.ID,
          ID_SOIL: this.itemToEdit.ID_SOIL,
          ID_FARM: this.itemToEdit.ID_FARM,
          FARM_NAME: this.itemToEdit.FARM_NAME,
          SOIL_NAME: "",
          SECTOR_NAME: this.form.NAME,
          IS_MANAGEMENT: this.itemToEdit.IS_MANAGEMENT,
          INITIAL_STORAGE: this.itemToEdit.INITIAL_STORAGE,
          VOLUME_DATE: this.itemToEdit.VOLUME_DATE,
        };
        this.getSelectedManagementOptions();
      }
    }

    const stationInfo = await monit.station();

    if (stationInfo && !stationInfo.status) {
      this.hasStation = false;
    }
    this.showForm = true;
  },
  data() {
    return {
      showForm: false,
      loading: false,
      currentLoadingMessage: "",
      modalName: "",
      modalElements: {
        elementsType: "",
        typeName: "",
        selectType: "",
        items: [],
        selected: [],
      },
      isLoad: false,
      // equipment: [],
      showEquipmentsModal: false,
      cont: 0,
      isFiltered: false,
      hasManagementAcess: false,
      loadingMessages: {
        actuator: {
          get: "Buscando dados da válvula...",
        },
        sector: {
          create: "Criando setor...",
          update: "Atualizando dados adicionais do setor de manejo...",
        },
        management: {
          calc: "Calculando dados de manejo...",
          create: "Salvando dados calculados de manejo...",
          delete: "Apagando dados de manejo do setor...",
        },
      },
      hasAccess: Boolean,
      valves: [],
      pumps: [],
      sensors: [],
      hydros: [],
      hasStation: true,
      firstEt0Register: null,
      form: {
        NAME: "",
        AREA: "",
        PLANTING_TYPE: "",
        PLANTING_DATE: "",
        NOTE: "",
      },
      managementForm: {
        START_NEW_CYCLE: true,
        OFFSET_DAP: 0,
        DATE_CROP: "",
        VOLUME_DATE: "",
        SPACING_BETWEEN_LINES: 0,
        SPACING_BETWEEN_PLANTS: 0,
        PRESSURIZE_TIME: 0,
        TIME_ADVANCE: 0,
        AVG_TIME_PULSE: 0,
        APPLICATION_RATE: 0,
        SYSTEM_EFFICIENCY: 0,
        ID_SECTOR: null,
        ID_SOIL: null,
        ID_FARM: null,
        SECTOR_NAME: null, //Apenas para salvar novo setor,
        IS_MANAGEMENT: false,
        INITIAL_STORAGE: 0,
        MAX_STORAGE: null,
      },
      managementSoil: [],
      managementFarms: [],
      managementDaps: [-2, -1, 0, 1, 2],
      equipment: [],
      allSelected: {
        valves: false,
        hydros: false,
        pumps: false,
        sensors: false,
      },
      selected: {
        valves: [],
        hydros: [],
        pumps: [],
        sensors: [],
        farm: {},
        soil: {},
      },
      isFiltered: false,
      filteredElements: [],
      search: "",
      oldValveItem: null, //(Edição)Válvula anterior
      oldManagementInitialDateItem: null, //(Edição) data de início de manejo anterior
      loadingLogOptions: false,
      controller: null,
      errors: [],
      alertValvesWithDiffTimes: null,
      ignoreAlertFromValves: false,
      hasChangedOnlyNote: false,
      hasChangedDateCrop: false,
    };
  },
  watch: {
    loading(newValue) {
      if (this.isSectorRegister) {
        if (newValue == true) {
          this.$refs.dialogWait.show();
        } else {
          this.$refs.dialogWait.hide();
          this.isSectorRegister = false;
        }
      } else {
        if (newValue) {
          wait.show();
        } else {
          wait.hide();
        }
      }
    },

    "selected.valves": function () {
      this.ignoreAlertFromValves = false;
      this.allSelected.valves =
        this.selected.valves.length == this.valves.length;
    },
    "selected.hydros": function () {
      this.allSelected.hydros =
        this.selected.hydros.length == this.hydros.length;
    },
    "selected.pumps": function () {
      this.allSelected.pumps = this.selected.pumps.length == this.pumps.length;
    },
    isManagement: {
      async handler(newVal) {
        if (newVal) {
          this.firstEt0Register = await this.getFirstEt0Day();
        }
      },
    },
    "selected.sensors": function () {
      if (this.selected.sensors.length > 0) {
        this.allSelected.sensors =
          this.selected.sensors.length == this.sensors.length;
      }
    },
    changeManagementDatas: {
      async handler() {
        console.log("Teste");
        const today = this.managementForm.VOLUME_DATE;
        const diff = moment(today).diff(this.form.PLANTING_DATE, "days");
        // const aux = moment(this.form.PLANTING_DATE).diff(this.form. , "days");

        let DAP = null;
        // Data de hoje superior a data de plantio
        if (diff >= 0) {
          DAP = diff + 1 + Number(this.managementForm.OFFSET_DAP);
        }
        //Data de hoje antes da data de plantio
        else if (diff < 0) {
          DAP = 0;
        }
        // console.log({ DAP });

        if (DAP !== null) {
          let farm_dap = await getFarmDapByFarmAndDAPUseCase().execute(
            this.managementForm.ID_FARM,
            DAP
          );

          if (!farm_dap) {
            //Pegar último registro de FARM_DAP
            farm_dap = await getFarmDapByLastRecordUseCase().execute(
              this.managementForm.ID_FARM
            );
          }
          const soil = await soilUseCase().showSoilByIdUseCase.execute(
            this.managementForm.ID_SOIL
          );

          //   console.log(farm_dap, " ", soil);
          const MAX_STORAGE = fixFloatValue(
            soil.WATER_DISPONIBILITY * farm_dap.DEPTH_ROOT
          );

          console.log(DAP);
          this.managementForm.MAX_STORAGE = MAX_STORAGE;
        }
      },
    },
  },
  computed: {
    valveSelectionInputFeedback() {
      return this.selected.valves
        .filter((valve) => valve.SECTORS && valve.SECTORS.length > 0)
        .map((valve) => {
          let sectorNames = valve.SECTORS.map((sector) => sector.NAME);

          if (this.formType == "edit") {
            sectorNames = sectorNames.filter((item) => item != this.form.NAME);
          }

          return {
            valve: valve.NAME,
            sectors: sectorNames.join(", "),
          };
        })
        .filter((valve) => valve.sectors.length != 0);
    },
    oldName() {
      return this.itemToEdit && this.itemToEdit.NAME;
    },
    changeManagementDatas() {
      const {
        managementForm: {
          OFFSET_DAP,
          ID_FARM,
          ID_SOIL,
          DATE_CROP,
          VOLUME_DATE,
          INITIAL_STORAGE,
        },
        form: { PLANTING_DATE },
      } = this;
      if (
        PLANTING_DATE &&
        OFFSET_DAP >= 0 &&
        ID_FARM >= 0 &&
        ID_SOIL >= 0 //&&
        // DATE_CROP
      ) {
        return {
          PLANTING_DATE,
          OFFSET_DAP,
          ID_FARM,
          ID_SOIL,
          DATE_CROP,
          VOLUME_DATE,
          INITIAL_STORAGE,
        };
      }
    },
    isManagement() {
      return this.managementForm && this.managementForm.IS_MANAGEMENT;
    },
    validManagementDate() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        this.managementForm.VOLUME_DATE !== ""
      ) {
        return (
          this.convertDateStringToDate(
            this.managementForm.VOLUME_DATE
          ).getFullYear() > 2000
        );
      }

      return true;
    },
    isValidStationStart() {
      if (this.hasStation) {
        return true;
      } else if (!this.managementForm.VOLUME_DATE || !this.firstEt0Register) {
        return false;
      } else if (
        !moment(this.managementForm.VOLUME_DATE).isBefore(this.firstEt0Register)
      ) {
        return true;
      } else {
        return false;
      }
    },
    // selectedItem() {
    //   return this.selected[this.equipment.type];
    // },
    eqps() {
      if (this.isFiltered) {
        return this.filteredElements;
      }
      return this.tableList;
    },
    tableList() {
      return this.equipment;
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
    nameState() {
      return !!this.form.NAME;
    },
    areaState() {
      let regex = /^[0-9.]*$/;
      let value = this.form.AREA;
      if (value) {
        return regex.test(value);
      }
      if (this.managementForm.IS_MANAGEMENT && !value) {
        return false;
      }
      return true;
    },
    farmState() {
      if (this.managementForm.IS_MANAGEMENT && !this.managementForm.ID_FARM) {
        return false;
      }
      return true;
    },
    soilState() {
      if (this.managementForm.IS_MANAGEMENT && !this.managementForm.ID_SOIL) {
        return false;
      }
      return true;
    },
    spaceBetweensPlantsState() {
      let value = Number(this.managementForm.SPACING_BETWEEN_PLANTS);
      if (this.managementForm.IS_MANAGEMENT && value > 0) {
        return true;
      }
      return false;
    },
    spaceBetweensLinesState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.SPACING_BETWEEN_LINES) > 0
      ) {
        return true;
      }
      return false;
    },
    pressurizeTimeState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.PRESSURIZE_TIME) > 0
      ) {
        return true;
      }
      return false;
    },
    timeAdvanceState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.TIME_ADVANCE) > 0
      ) {
        return true;
      }
      return false;
    },
    avgTimePulseState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.AVG_TIME_PULSE) > 0
      ) {
        return true;
      }
      return false;
    },
    applicationRateState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.APPLICATION_RATE) > 0
      ) {
        return true;
      }
      return false;
    },
    systemEfficiencyState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        Number(this.managementForm.SYSTEM_EFFICIENCY) >= 1 &&
        Number(this.managementForm.SYSTEM_EFFICIENCY) <= 100
      ) {
        return true;
      }
      return false;
    },
    offSetDapState() {
      if (
        this.managementForm.IS_MANAGEMENT &&
        this.managementForm.OFFSET_DAP !== null
      ) {
        return true;
      }
      return false;
    },
    dateCropState() {
      if (this.managementForm.IS_MANAGEMENT) {
        if (!this.form.PLANTING_DATE && this.managementForm.DATE_CROP) {
          return false;
        }
        if (this.managementForm.DATE_CROP) {
          if (this.managementForm.VOLUME_DATE) {
            return moment(this.managementForm.DATE_CROP).isAfter(
              moment(this.managementForm.VOLUME_DATE)
            );
          }
          let diff = moment(this.managementForm.DATE_CROP).diff(
            moment(this.form.PLANTING_DATE),
            "days"
          );
          if (diff > 0) {
            return true;
          }

          return false;
        }
      }

      return true;
    },
    managementInitialDateState() {
      if (this.managementForm.VOLUME_DATE) {
        const today = moment().format("YYYY-MM-DD");
        return this.managementForm.VOLUME_DATE < today;
      } else return true;
    },
    plantingDateState() {
      if (this.managementForm.IS_MANAGEMENT) {
        if (!this.form.PLANTING_DATE) {
          return false;
        }

        return (
          this.convertDateStringToDate(this.form.PLANTING_DATE).getFullYear() >
          2000
        );
      }
      return true;
    },
    dateCropInputState() {
      if (this.managementForm.IS_MANAGEMENT && !this.managementForm.DATE_CROP) {
        return (
          this.convertDateStringToDate(
            this.managementForm.DATE_CROP
          ).getFullYear() > 2000
        );
      }

      return true;
    },
  },
  methods: {
    openModal(
      modalName,
      { elementsType, typeName, selectType, items, selected }
    ) {
      this.modalName = modalName;
      if (selectType == "selectRadio" && selected) {
        selected = selected[0];
      }
      this.modalElements = {
        elementsType,
        typeName,
        selectType,
        items,
        selected,
      };
      if (this.isLoad) {
        this.showEquipmentsModal = true;
      }
    },
    setSelected(selected, type) {
      this.selected[type] = selected;
      if (type == "soil") {
        this.managementForm.ID_SOIL = this.selected[type].ID;
        this.managementForm.SOIL_NAME = this.selected[type].NAME;
      }
      if (type == "farm") {
        this.managementForm.ID_FARM = this.selected[type].ID;
        this.managementForm.FARM_NAME = this.selected[type].NAME;
      }
    },
    getSelectedManagementOptions() {
      const getterSelectedSoil = this.managementSoil.filter(
        (soil) => soil.ID == this.managementForm.ID_SOIL
      );
      const getterSelectedFarm = this.managementFarms.filter(
        (farm) => farm.ID == this.managementForm.ID_FARM
      );
      this.selected.soil = getterSelectedSoil[0];
      this.selected.farm = getterSelectedFarm[0];
      this.managementForm.SOIL_NAME = this.selected.soil.NAME;
    },

    async onSubmitForm(SECTOR_PROPS) {
      try {
        // console.log("SECTORPORPS", SECTOR_PROPS);
        const hasManagementProps = Reflect.has(SECTOR_PROPS, "MANAGEMENT");
        const isManagementSector = hasManagementProps
          ? SECTOR_PROPS.MANAGEMENT.IS_MANAGEMENT
          : null;

        this.isSectorRegister = true;
        this.loading = true;
        this.currentLoadingMessage = "Aguarde...";

        const ret = await sectors[this.formType](SECTOR_PROPS.SECTOR);

        alert(ret.log, ret.alert);

        if (ret.alert !== "s") {
          throw new Error(`Falha ao cadastrar dados do setor - ${ret.log}`);
        }

        if (!SECTOR_PROPS.HAS_CHANGED_ONLY_NOTE && this.hasManagementAcess) {
          if (hasManagementProps && isManagementSector) {
            this.currentLoadingMessage = this.loadingMessages.actuator.get;
            this.currentValves = await this.getValveInfo(SECTOR_PROPS);

            const hasFarmDap = await checkIfFarmDapExists.execute(
              SECTOR_PROPS.MANAGEMENT.ID_FARM
            );

            if (!hasFarmDap) {
              throw "Não existe dados de DAP do cultivar, não irá ser possível calcular o manejo!";
            }

            const sectorId =
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR || SECTOR_PROPS.SECTOR.ID;

            const rainfall_inputs =
              await getManagementRainfallInputByIdlUseCase().execute(sectorId);

            if (this.formType === "add") {
              SECTOR_PROPS.MANAGEMENT.ID_SECTOR = ret.value;

              this.currentLoadingMessage = this.loadingMessages.sector.create;
              await managementSectorUseCases()[this.formType].execute(
                SECTOR_PROPS.MANAGEMENT
              );

              await this.registerManagementSectorAux(SECTOR_PROPS);
            } else if (this.formType === "edit") {
              this.currentLoadingMessage = this.loadingMessages.sector.update;
              await this.updateSectorHandler(SECTOR_PROPS);
            }

            this.currentLoadingMessage = this.loadingMessages.management.calc;
            const managementData = await this.calcManagementData(
              SECTOR_PROPS,
              rainfall_inputs
            );

            if (managementData.length) {
              this.currentLoadingMessage =
                this.loadingMessages.management.create;
              await this.registerManagement(sectorId, managementData);
            }
          } else {
            const sectorId =
              SECTOR_PROPS.SECTOR.ID || SECTOR_PROPS.MANAGEMENT.ID_SECTOR;

            if (sectorId) {
              if (SECTOR_PROPS.MANAGEMENT.ID_SECTOR != null) {
                this.currentLoadingMessage =
                  this.loadingMessages.management.delete;
              }
              await this.deleteManagementDatasFromSector(sectorId);
            }
          }
        }

        const ID_USER = cookies.get("ID");

        if (this.hasManagementAcess) {
          await managementSectorUseCases().updateFkEditor.execute(
            SECTOR_PROPS.SECTOR.ID || SECTOR_PROPS.MANAGEMENT.ID_SECTOR,
            ID_USER
          );
        }
      } catch (error) {
        console.error(error);
        alert(
          `Ocorreu um erro ao ${
            this.formType === "add" ? "adicionar" : "editar"
          } setor. Erro: ${error}`,
          "e"
        );
      } finally {
        this.reload();
        this.recalcUntilDateCrop = false;
        this.loading = false;
      }
    },

    reload() {
      this.$emit("get-data-again");
      this.$emit("close-form");
    },
    async loadEquipments(type) {
      this.isLoad = false;
      try {
        const hydrosPromise = sectors.hydros();
        const pumpsPromise = sectors.pumps();
        const valvesPromise = sectors.valves();
        const sensorsPromise = sectors.sensors();

        const [hydrosResponse, pumpsResponse, valvesResponse, sensorsResponse] =
          await Promise.allSettled([
            hydrosPromise,
            pumpsPromise,
            valvesPromise,
            sensorsPromise,
          ]);

        this.hydros = hydrosResponse.value;
        this.pumps = pumpsResponse.value;
        this.valves = valvesResponse.value;
        this.sensors = sensorsResponse.value;

        if (type !== "add") {
          const hydroIDs = this.itemToEdit.hydros.map((se) => se.ID_HYDRO);
          if (hydroIDs[0] !== null) {
            this.selected.hydros = this.hydros.filter((e) =>
              hydroIDs.includes(e.ID)
            );
          }

          const pumpIDs = this.itemToEdit.pumps.map((se) => se.ID_PUMP);
          if (pumpIDs[0] !== null) {
            this.selected.pumps = this.pumps.filter((e) =>
              pumpIDs.includes(e.ID)
            );
          }

          const valveIDs = this.itemToEdit.valves.map((se) => se.ID_VALVE);
          if (valveIDs[0] !== null) {
            this.selected.valves = this.valves.filter((e) =>
              valveIDs.includes(e.ID)
            );
          }

          const sensorIDs = this.itemToEdit.sensors.map((se) => se.ID_SENSOR);
          if (sensorIDs[0] !== null) {
            this.selected.sensors = this.sensors.filter((e) =>
              sensorIDs.includes(e.ID)
            );
          }
        }
      } catch (err) {
        console.error(err);
        alert("Erro ao buscar equipamentos para formulário.");
      } finally {
        this.isLoad = true;
      }
    },
    moment,
    async incrementCycleCount({ idSector }) {
      try {
        await management.incrementManagementCycle({ idSector });
        alert("Sucesso ao salvar histórico do ciclo antes da alteração", "s");
      } catch (e) {
        alert(
          "Ocorreu um erro ao salvar histórico do ciclo antes da alteração",
          "e"
        );
      }
    },
    async getFirstEt0Day() {
      const raw = `
        SELECT MIN((FIRST_ET0.TIME)) TIME
        FROM CROP.ET0 FIRST_ET0;
      `;

      const first_et0_day = await management
        .sql({
          data: {
            sql: raw,
          },
        })
        .then((resp) => (resp[0] && resp[0].length ? resp[0][0] : {}))
        .catch((err) => {
          console.log(err);
          return {};
        });

      return first_et0_day && first_et0_day.TIME;
    },
    managementVolumeDateFormatter(date) {
      let yesterday = moment().subtract(1, "day").format("YYYY-MM-DD");
      if (date >= yesterday) {
        return yesterday;
      }
      return date;
    },
    isMobile(ref) {
      return isMobile(ref);
    },
    async loadSoils() {
      // soilService.show
      const data = await soilUseCase().show.execute();

      const [soils, _] = data;
      if (soils) {
        soils.forEach((soil) => {
          this.managementSoil.push({
            ID: soil.ID,
            NAME: soil.NAME,
          });
        });
      }
    },
    async loadFarms() {
      const data = await farmUseCase().show.execute();

      const [farms, _] = data;
      if (farms) {
        farms.map((farm) => {
          this.managementFarms.push({
            ID: farm.ID,
            NAME: farm.NAME,
          });
        });
      }
    },
    resetForm() {
      this.form = {
        NAME: "",
        AREA: "",
        PLANTING_TYPE: "",
        PLANTING_DATE: "",
        NOTE: "",
      };

      this.equipment = [];
      this.allSelected = {
        valves: false,
        hydros: false,
        pumps: false,
        sensors: false,
      };
      this.selected = {
        valves: [],
        hydros: [],
        pumps: [],
        sensors: [],
      };
      this.managementForm = {
        OFFSET_DAP: 0,
        DATE_CROP: "",
        VOLUME_DATE: "",
        SPACING_BETWEEN_LINES: 0,
        SPACING_BETWEEN_PLANTS: 0,
        PRESSURIZE_TIME: 0,
        TIME_ADVANCE: 0,
        AVG_TIME_PULSE: 0,
        APPLICATION_RATE: 0,
        SYSTEM_EFFICIENCY: 0,
        INITIAL_STORAGE: 0,
        ID_SECTOR: null,
        ID_SOIL: null,
        ID_FARM: null,
        SECTOR_NAME: null, //Apenas para salvar novo setor
        IS_MANAGEMENT: false,
        MAX_STORAGE: null,
      };
    },
    ignoreAlertsFromValve() {
      this.ignoreAlertFromValves = true;
      this.$refs.alertValves.hide();
    },
    async checkLogsFromValves() {
      const { oldValves, valves } = this.form;
      //Não tiver válvula anterior atrelado ao setor antes ou clicar em editar e não trocar a válvula
      if (!oldValves) {
        return false;
      }

      const valve_name = valves[0].NAME;

      // Primeiro registro da válvula no LOG_ACTUATOR
      // first_record_from_valve=[{TIME:"YYYY-MM-DD HH:mm:ss"}]
      const first_record_from_valve = await showLasRecord.execute(valve_name);
      //Se não tiver registro da válvula nova e nem tiver detectado a válvula antiga

      const old_valve_name = oldValves[0].NAME;
      const first_record_from_last_valve = await showLasRecord.execute(
        old_valve_name
      );
      // Caso não tiver nenhum primeiro registro das válvulas no LOG_ACTUAOTR
      if (!first_record_from_last_valve && !first_record_from_valve) {
        return false;
      }

      if (
        (first_record_from_last_valve &&
          first_record_from_last_valve.length &&
          !first_record_from_valve) ||
        (!first_record_from_last_valve &&
          first_record_from_valve &&
          first_record_from_valve.length)
      ) {
        return true;
      }
      let first_valve_time = moment(first_record_from_valve[0].TIME);
      let last_valve_time = moment(first_record_from_last_valve[0].TIME);
      let diff = first_valve_time.diff(last_valve_time, "day");

      if (Math.abs(diff) > 0) {
        // Aviso
        // this.$refs.registerValvesSectorDialog.show();
        return true;
      }
      //Se não tiver encontrado a válvula anterior
    },
    checkIfPropsHasChanged() {
      const oldForm = {
        ID: this.itemToEdit.ID,
        NAME: this.itemToEdit.NAME,
        AREA: this.itemToEdit.AREA,
        PLANTING_TYPE: this.itemToEdit.PLANTING_TYPE,
        PLANTING_DATE: this.itemToEdit.PLANTING_DATE,
        NOTE: this.itemToEdit.NOTE,
        OFFSET_DAP: this.itemToEdit.OFFSET_DAP,
        DATE_CROP: this.itemToEdit.DATE_CROP,
        SPACING_BETWEEN_LINES: this.itemToEdit.SPACING_BETWEEN_LINES,
        SPACING_BETWEEN_PLANTS: this.itemToEdit.SPACING_BETWEEN_PLANTS,
        PRESSURIZE_TIME: this.itemToEdit.PRESSURIZE_TIME,
        TIME_ADVANCE: this.itemToEdit.TIME_ADVANCE,
        AVG_TIME_PULSE: this.itemToEdit.AVG_TIME_PULSE,
        APPLICATION_RATE: this.itemToEdit.APPLICATION_RATE,
        SYSTEM_EFFICIENCY: this.itemToEdit.SYSTEM_EFFICIENCY,
        ID_SECTOR: this.itemToEdit.ID,
        ID_SOIL: this.itemToEdit.ID_SOIL,
        ID_FARM: this.itemToEdit.ID_FARM,
        SECTOR_NAME: this.form.NAME,
        IS_MANAGEMENT: this.itemToEdit.IS_MANAGEMENT,
        INITIAL_STORAGE: this.itemToEdit.INITIAL_STORAGE,
        VOLUME_DATE: this.itemToEdit.VOLUME_DATE,
      };

      const newForm = {
        ...this.managementForm,
        ...{
          ID: this.form.ID,
          NAME: this.form.NAME,
          AREA: this.form.AREA,
          PLANTING_TYPE: this.form.PLANTING_TYPE,
          PLANTING_DATE: this.form.PLANTING_DATE,
          NOTE: this.form.NOTE,
        },
      };

      Reflect.deleteProperty(newForm, "MAX_STORAGE");

      const result = [];

      for (const [key, value] of Object.entries(newForm)) {
        if (value !== oldForm[key]) {
          result.push(key);
        }
      }

      this.hasChangedOnlyNote = result.length
        ? result.every((value) => value === "NOTE")
        : false;

      const hasChangedDateCrop = result.length
        ? result.some((value) => value === "DATE_CROP")
        : false;
      this.hasChangedDateCrop = hasChangedDateCrop;
    },
    convertDateStringToDate(dateString, separator = "-") {
      const [year, month, day] = dateString.split(separator);
      return new Date(year, month - 1, day);
    },
    async checkForm() {
      this.errors = [];
      for (let key of Object.keys(this.form)) {
        if (this.form[key] == "") this.form[key] = null;
      }

      let states = [this.nameState, this.notRepeatedName, this.areaState];
      let erros = [
        "Nome é obrigatório.",
        "O nome escolhido já está em uso.",
        "Use ponto no lugar de vírgula para indicar valores decimais.",
      ];

      if (this.managementForm.IS_MANAGEMENT) {
        states = [
          ...states,
          this.farmState,
          this.soilState,
          this.spaceBetweensPlantsState,
          this.spaceBetweensLinesState,
          this.systemEfficiencyState,
          this.offSetDapState,
          this.dateCropState,
          this.plantingDateState,
          this.validManagementDate,
        ];

        erros = [
          ...erros,
          "É necessário informar o cultivar",
          "É necessário informar o solo",
          "É necessário informar o espaçamento entre plantas",
          "É necessário informar o espaçamento entre linhas",
          // "É necessário informar o tempo de Pressurização ",
          // "É necessário informar o tempo de avanço",
          // "É necessário informar o tempo médio de pulso",
          "É necessário informar a eficiência do sistema",
          "É necessário informar a offset DAP",
          "É necessário informar a data de colheita e ela deverá ser superior a data de plantio",
          "É necessário informar a data de plantio",
          "É necessário informar uma data inicial de manejo válida",
        ];

        states.map((e, i) => {
          if (!e) this.errors.push(erros[i]);
        });

        // Se o checkbox de manejo for selecionado, então deverá poder selecionar no máximo uma válvula
        // por setor
        if (this.selected.valves.length > 1) {
          this.errors.push(
            "Não pode selecionar mais de uma válvula quando for manejo"
          );
        }

        if (!this.selected.valves.length) {
          this.errors.push("É necessário ter uma válvula para setor de manejo");
        }

        // if (!this.validManagementDate && this.firstEt0Register) {
        //   this.errors.push(
        //     `Só é possível criar manejo a partir do dia: ${moment(
        //       this.firstEt0Register
        //     ).format("DD/MM/YYYY")}`
        //   );
        // }
        // else if (!this.validManagementDate && !this.firstEt0Register) {
        //   this.errors.push(
        //     "Não existem dados de ET0 e precipitação registrados ainda, cadastre-os antes de registrar o setor."
        //   );
        // }
      } else {
        states.map((e, i) => {
          if (!e) this.errors.push(erros[i]);
        });
      }

      this.form.valves = this.selected.valves;
      this.form.hydros = this.selected.hydros;
      this.form.sensors = this.selected.sensors;
      this.form.pumps = this.selected.pumps;

      if (this.formType == "edit" && this.managementForm.IS_MANAGEMENT) {
        this.managementForm.SECTOR_NAME = this.form.NAME;
        //Data de manejo anterior
        //Caso for detectado alguma modificação na data, então coloca a mais recente
        this.form.oldManagementInitialDate =
          this.oldManagementInitialDateItem !== this.managementForm.VOLUME_DATE
            ? this.managementForm.VOLUME_DATE
            : null;
        //Válvula anterior - só para caso de edição
        //  console.log(this.oldValveItem)

        if (this.oldValveItem.length) {
          //Deve receber valor diferente da válvula atual
          this.form.oldValves =
            this.oldValveItem[0].ID !== this.form.valves[0].ID
              ? this.oldValveItem
              : null;
        }
        if (!this.ignoreAlertFromValves) {
          this.alertValvesWithDiffTimes = await this.checkLogsFromValves();
        }
        this.checkIfPropsHasChanged();
      }

      if (this.errors.length) this.$refs.formError.show();
      else if (!this.ignoreAlertFromValves && this.alertValvesWithDiffTimes)
        this.$refs.alertValves.show();
      else {
        // this.managementForm.SYSTEM_EFFICIENCY=this.managementForm.SYSTEM_EFFICIENCY/100
        if (this.managementForm.START_NEW_CYCLE && this.form.ID) {
          //console.log('ta adicionando o ciclo antes de tudo')
          await this.incrementCycleCount({ idSector: this.form.ID });
        }
        await this.onSubmitForm({
          SECTOR: this.form,
          MANAGEMENT: {
            ...this.managementForm,
            SYSTEM_EFFICIENCY: this.managementForm.SYSTEM_EFFICIENCY / 100,
          },
          HAS_CHANGED_ONLY_NOTE: this.hasChangedOnlyNote,
          HAS_CHANGED_DATE_CROP: this.hasChangedDateCrop,
        });
      }
    },
    toggleAll(str) {
      this.allSelected[str] = !this.allSelected[str];
      if (this.selected[str].length < this[str].length) {
        this.selected[str] = this[str].slice();
      } else if (this.selected[str].length == this[str].length) {
        this.selected[str] = [];
      }
    },
  },
};
</script>

<style scoped>
.count-notes-chars {
  font-size: 0.8em;
  text-align: end;
  color: var(--text-gray-secondary);
}
.equipment-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.max-storage-feedback {
  font-size: 0.8em;
  /* color: var(--text-gray-secondary); */
}

@media screen and (max-width: 767px) {
  .container {
    padding-bottom: 3em;
  }

  #form .row {
    padding-bottom: 2em;
  }

  #form,
  #details {
    padding-top: 1em;
  }
}
</style>
